import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme: { colors } }) => css`
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    width: 585px;
    max-width: 100%;
    gap: 32px;

    > header {
      display: flex;
      align-items: center;
      gap: 16px;

      > div:first-of-type {
        flex: 1;
      }

      > div:last-of-type {
        width: 32px;
      }

      svg {
        color: ${colors.green2};
        justify-self: center;
        cursor: pointer;
      }
    }

    > main {
      min-height: 340px;
    }

    > footer {
      display: flex;
      justify-content: center;
    }
  `}
`;
